import { render, staticRenderFns } from "./TruckMap.vue?vue&type=template&id=5cd031ff&scoped=true"
import script from "./TruckMap.vue?vue&type=script&lang=ts"
export * from "./TruckMap.vue?vue&type=script&lang=ts"
import style0 from "./TruckMap.vue?vue&type=style&index=0&id=5cd031ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd031ff",
  null
  
)

export default component.exports